const KB = 1024;
export const BYTES_PER_MB = KB * 1024;

export const formatFileSize = (bytes: number): string => {
  if (bytes < KB) return `${bytes} B`;
  const kilobytes = Math.round(bytes / KB);
  if (kilobytes < KB) return `${kilobytes} KB`;
  return `${(bytes / BYTES_PER_MB).toFixed(1)} MB`;
};
